import { useId, useMemo } from 'react'
import logoSvgRaw from '@/assets/LOGO_RP.svg?raw'

function buildSvgMarkup(uid: string): string {
  let html = logoSvgRaw.replace(/<\?xml[^?]*\?>\s*/i, '')
  const clip1 = `clippath-1-${uid}`
  const clip0 = `clippath-${uid}`
  html = html.replace(/\bid="clippath-1"/g, `id="${clip1}"`)
  html = html.replace(/\bid="clippath"/g, `id="${clip0}"`)
  html = html.replace(/url\(#clippath-1\)/g, `url(#${clip1})`)
  html = html.replace(/url\(#clippath\)/g, `url(#${clip0})`)
  return html
}

interface LogoRPProps {
  className?: string
}

export default function LogoRP({ className = '' }: LogoRPProps) {
  const uid = useId().replace(/:/g, '')
  const svgMarkup = useMemo(() => buildSvgMarkup(uid), [uid])

  return (
    <span
      // `shrink-0` at every breakpoint: keeps this logo at its natural
      // aspect-ratio width in a tight flex row (see the matching note in
      // LogoBrSE.tsx) instead of being squeezed down to fill whatever space
      // its sibling didn't take — shrinking this box doesn't shrink the SVG
      // (sized independently via `h-full`/aspect-ratio), it just lets the
      // `overflow-visible` SVG bleed back over the previous sibling.
      className={`inline-block max-w-full shrink-0 overflow-visible [&>svg]:block [&>svg]:h-full [&>svg]:w-auto [&>svg]:max-w-full [&>svg]:overflow-visible ${className}`}
      role="img"
      aria-label="BrSE.ai"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svgMarkup }}
    />
  )
}
